module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_16.8ff1126b.png";